import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2527bbb2&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2527bbb2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2527bbb2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2527bbb2')) {
      api.createRecord('2527bbb2', component.options)
    } else {
      api.reload('2527bbb2', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2527bbb2&scoped=true", function () {
      api.rerender('2527bbb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/maintain/ipBan/banRecord/index.vue"
export default component.exports